import styles from './UnderstandMobile.module.scss';
import childWithTablet from '../../images/child-with-tablet.png';
import teensWithPhones from '../../images/teens-with-phones.png';
import Button from '../Button';
import Statistics from '../Statistics';

function UnderstandMobile() {
  return (
    <div className={styles.understand}>
      <h2>
        Entenda melhor
        <br />
        <span>o problema</span>
      </h2>
      <div className={styles.container}>
        <div className={styles.content}>
          <p>
            Acreditamos que o <strong>uso excessivo</strong> de telas por
            crianças e adolescentes é um grave problema de saúde pública e
            precisamos agir rápido para que os efeitos não sejam ainda piores e
            talvez irreversíveis.
          </p>

          <div className={styles.statistics}>
            <Statistics
              number="90.000"
              description="passam 16h por dia na frente de telas"
            />
          </div>
        </div>

        <div className={styles.images}>
          <div className={styles.mainImage}>
            <img src={childWithTablet} alt="Criança usando tablet" />
          </div>
        </div>
      </div>
      <div className={styles.container}>
        <div className={styles.sideImage}>
          <img src={teensWithPhones} alt="Adolescentes usando celular" />
        </div>
        <div>
          <p>
            Em nosso blog discutimos mais sobre o problema e propomos soluções
            viáveis.
          </p>
          <div className={styles.button}>
            <Button variant="pink">Saiba Mais</Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UnderstandMobile;
